var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"types"},_vm._l((_vm.dataSource),function(item){
var _obj;
return _c('li',{key:item.value,staticClass:"types-item",class:( _obj = {selected: _vm.value === ("" + (item.value))}, _obj[_vm.classPrefix+'-tabItem'] = _vm.classPrefix, _obj ),on:{"click":function($event){return _vm.selectType(item)}}},[_vm._v(_vm._s(item.text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }